import { getAge } from '@/utils/dates';

export default {
    params: ['age'],
    validate: (value, { age }) => getAge(value) <= Number(age) || 'The {_field_} field must be a date younger than {age} years'
};